import { FeatureName } from "@accurx/auth";

export const PatientTriageFeatureFlags: FeatureName[] = [
    FeatureName.PatientInitiatedInbox,
    FeatureName.AccurxPlusPatientTriage,
    FeatureName.PatientTriageSolicitedAppointmentBooking,
    FeatureName.PatientTriageSolicitedAppointmentBookingSendLink,
    FeatureName.PatientTriageReceptionFlow,
    FeatureName.PatientTriageDashboards,
];
